<template lang="pug">
  .component-translation-add
    .row.column.card.pt-2
      .row
        .column
          label group
            select(v-model="body.group")
              option(v-for="group in groups" :value="group") {{group}}
        .column
          label key
            input(type="text", v-model="body.key")
      loading-spinner(v-if="!langs.length")
      .row
        .column
          label lang
        .column
          label value
      .row(v-for="lang in langs")
        .column.small-2.large-1.medium-1
            input(type="text", :value="lang" readonly='readOnly')
        .column
            textarea(v-model="body.value[lang]" :name='lang' rows="8")
      .row
        .column
          ActionButton(:action="save") {{firstSaving ? 'Save Translation' : 'Add Another Translation'}}

</template>

<script>
  import ActionButton from '../../components/structure/ui/ActionButton'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from "../../maggieHelper"
  import LoadingSpinner from "../../components/structure/LoadingSpinner";

  export default {
    name: 'TranslationAdd',
    components: {LoadingSpinner, ActionButton},
    data() {
      return {
        body : {
          group: '',
          key: '',
          value: {},
        },
        name:'',
        // translations: [],
        groups : ['notifications','exception','exceptions','flows','flow-image','hardware','paymentmethods','profile','reservation','reservations','results','subscription'],
        langs : [],
        firstSaving:true,
        otherSaving:false,
      }
    },
    created() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.langs = Object.keys(data.application['application_default_language']['possibile'])
      })
    },
    methods: {
      sanitazeNullValues(obj) {
        Object.entries(obj).forEach( o => (o[1] === null ? delete obj[o[0]] : 0));
      },
      save() {
        this.body.group.trim()
        this.body.key.trim()
        this.sanitazeNullValues(this.body.value)
        return KeplerBackofficeSdk.translations.make(this.body, (data) => {
          MaggieHelper.notification('Done', 'Translation created')
          this.firstSaving = this.otherSaving
          this.body = {
            group: '',
            key: '',
            value: {},
          }
        })
      }
    },
    computed: {

    },
    props: ['item']
  }
</script>

<style >


</style>



// WEBPACK FOOTER //
// TranslationAdd.vue?31ba5202